import "./../assets/card.scss";

import { getAppealPreview } from "@teams/cards";
import { TeamsApplicationTypes, TeamsSurveyDraft, TeamsUser } from "@teams/types";
import { useCallback, useEffect, useState } from "react";

import { ReactHTMLElement } from "../../../../../_shared/components/ReactHTMLElement";
import { useButton, useDefaultResponseValues, useTheme } from "./../hooks";
import { SurveyTakingPreview } from "./SurveyTakingPreview";

type Props = {
  draft: TeamsSurveyDraft;
  owner: TeamsUser;
  applicationType: TeamsApplicationTypes;
  tenantId: string;
};

export const QuizPreview: React.FC<Props> = props => {
  const [showPopup, setShowPopup] = useState(false);

  const generateCardHtml = useCallback(() => {
    const card = getAppealPreview(props.draft, props.owner, props.tenantId, props.applicationType);

    const html = card.render()!;

    return html;
  }, [props.applicationType, props.draft, props.owner, props.tenantId]);

  const [cardHtml, setCardHtml] = useState<HTMLElement>(() => generateCardHtml());
  useTheme(cardHtml);
  useDefaultResponseValues(cardHtml);

  useEffect(() => {
    setCardHtml(generateCardHtml());
  }, [generateCardHtml]);

  const { removeClickHandler, attachClickHandler, buttonLabels } = useButton(cardHtml);

  useEffect(() => {
    attachClickHandler(buttonLabels.StartQuizButtonLabel, () => {
      setShowPopup(true);
    });
  }, [attachClickHandler, buttonLabels.StartQuizButtonLabel]);

  useEffect(() => {
    removeClickHandler(buttonLabels.ViewResultsButtonLabel);
  }, [buttonLabels.ViewResultsButtonLabel, removeClickHandler]);

  return (
    <>
      {!showPopup && (
        <div className="card">
          <ReactHTMLElement html={cardHtml} />
        </div>
      )}

      {showPopup && (
        <SurveyTakingPreview
          draft={props.draft}
          owner={props.owner}
          applicationType={props.applicationType}
          tenantId={props.tenantId}
          closePopupHandler={() => setShowPopup(false)}
        />
      )}
    </>
  );
};
